import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      categoryMap: 'classifySoftware/categoryMap',
    })
  },
  methods: {
    // 匹配分类映射
    matchCategory(editorCId) {
      if (!editorCId && editorCId !== 0) { return {} }
      const cObj = this.categoryMap.find((c) => { return editorCId === c.componentEditorCategoryId })
      return cObj || {}
    },
  }
}
